'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _baseButtons = require('@bibliocommons/base-buttons');

var _baseIcons = require('@bibliocommons/base-icons');

var _baseScreenReaderMessage = require('@bibliocommons/base-screen-reader-message');

var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);

require('../styles/PrivacyTogglePills.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PrivacyTogglePills = function (_BcReactComponent) {
  _inherits(PrivacyTogglePills, _BcReactComponent);

  function PrivacyTogglePills(props) {
    _classCallCheck(this, PrivacyTogglePills);

    var _this = _possibleConstructorReturn(this, (PrivacyTogglePills.__proto__ || Object.getPrototypeOf(PrivacyTogglePills)).call(this, props));

    _this.bindAll('handleToggleClick');
    return _this;
  }

  _createClass(PrivacyTogglePills, [{
    key: 'handleToggleClick',
    value: function handleToggleClick(isPrivate) {
      if (this.props.isPrivate === isPrivate) {
        return;
      }

      this.props.handlePrivacyToggle(isPrivate);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var isPrivate = this.props.isPrivate;

      return _react2.default.createElement(
        'div',
        { className: 'cp-privacy-toggle-pills' },
        _react2.default.createElement(
          _baseScreenReaderMessage2.default,
          { 'aria-live': 'polite' },
          isPrivate ? _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'item_is_private' }) : _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'item_is_shared' })
        ),
        _react2.default.createElement(
          _baseButtons.DefaultButton,
          {
            className: (0, _classnames2.default)('privacy-toggle-btn', 'lock', { selected: isPrivate }),
            handleClick: function handleClick() {
              return _this2.handleToggleClick(true);
            },
            'aria-label': this.props.intl.formatMessage({ id: 'change_item_privacy_to_private' }) },
          _react2.default.createElement(_baseIcons.Lock, null)
        ),
        _react2.default.createElement(
          _baseButtons.DefaultButton,
          {
            className: (0, _classnames2.default)('privacy-toggle-btn', 'unlock', { selected: !isPrivate }),
            handleClick: function handleClick() {
              return _this2.handleToggleClick(false);
            },
            'aria-label': this.props.intl.formatMessage({ id: 'change_item_privacy_to_shared' }) },
          _react2.default.createElement(_baseIcons.Unlock, null)
        )
      );
    }
  }]);

  return PrivacyTogglePills;
}(_baseBcReactComponent2.default);

PrivacyTogglePills.propTypes = {
  isPrivate: _react.PropTypes.bool.isRequired,
  handlePrivacyToggle: _react.PropTypes.func.isRequired
};

PrivacyTogglePills.displayName = 'PrivacyTogglePills';

exports.default = (0, _reactIntl.injectIntl)(PrivacyTogglePills);


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/shared-privacy-toggle-pills/lib/components/PrivacyTogglePills.component.js
// module id = 1501
// module chunks = 1